import cn from 'classnames';
import { useBuybackContext } from '@/lib/buyback/BuybackContext';
import { priceFormater } from '@/settings/index';
import settings from '@/settings';
import TradeInLogo from '../collections/[handle]/NewProductPage/TradeIn/TradeInLogo';

const TradeInItem = ({
  isItemsVisible,
  isCheckout,
  tradeInItem,
}: {
  isItemsVisible: boolean;
  isCheckout?: boolean;
  tradeInItem?: {
    title: string;
    price: number;
  };
}) => {
  const { quote, resetQuote, finalQuote } = useBuybackContext();

  if (
    !tradeInItem &&
    (!['reebelo-dev', 'reebelo-us'].includes(settings.store) ||
      !quote?.isAccepted ||
      !finalQuote?.paymentMethod ||
      !isItemsVisible)
  )
    return null;

  const lineItem = {
    title: tradeInItem?.title ?? quote?.model.split(' - ')[0] ?? '',
    price: tradeInItem?.price ?? quote?.['basePrice-used'] ?? 0,
  };

  if (lineItem.price === 0 || !lineItem.title) return null;

  return (
    <div
      className={cn('group w-full', {
        'border-b p-4 pl-0 pr-0 xl:p-5 xl:pl-5 xl:pr-5': !isCheckout,
      })}
    >
      <div className="flex w-full gap-2">
        <TradeInLogo />
        <div
          className="flex w-3/5 flex-col justify-center px-1 text-sm xxs:w-2/3 xs:w-3/4 sm:px-2"
          id="e2e-cart-line-item-trade-in"
        >
          <h5
            // eslint-disable-next-line tailwindcss/no-custom-classname
            className="mb-[3px] font-bold !leading-tight text-gray-700"
          >
            Money you get back from trade-in
          </h5>

          <span>{lineItem.title}</span>
        </div>
        <div
          className={cn('flex w-2/5 flex-col items-end xxs:w-1/3 xs:w-1/4', {
            'justify-between': !isCheckout,
            'justify-center': isCheckout,
          })}
        >
          <span className="text-sm font-bold text-[#136943]">
            {priceFormater.long(lineItem.price)}
          </span>
          {!isCheckout && (
            <button
              type="button"
              onClick={() => {
                resetQuote();
              }}
              className="text-xs underline hover:text-blue-500"
            >
              Remove
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TradeInItem;
